// lib
import { useMemo } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { TYPE_CLASS_MAP } from '@aytm/app/stats/page/question-views/components/lib/constants'

// components
import { Button } from 'primereact/button'

// styles
import { resolveToolUpdateNoun } from '@aytm/app/stats/page/question-views/components/lib/tool-meta'

import style from '@aytm/app/stats/page/question-views/components/questions-custom/styles/Footer.module.scss'

const Footer = ({ children, model, states, updateTextPrefix, onUpdateData }) => {
  const updateText = useMemo(
    () =>
      `${updateTextPrefix ? updateTextPrefix : states.updated ? 'Updat' : 'Generat'}${
        updateTextPrefix ? '' : states.loading ? 'ing' : 'e'
      } ${resolveToolUpdateNoun(model?.type, model?.insightsMapping)}`,
    [model?.type, model?.insightsMapping, states.loading, states.updated, updateTextPrefix]
  )
  const updateDisabled = useMemo(
    // a run that failed stays on offer beside its message; any other error holds it back
    () => (states.error && !states.retry) || states.loaded || states.loading || states.disabled.update,
    [states.error, states.retry, states.loaded, states.loading, states.disabled.update]
  )

  return (
    <div className={`${style.component} ${style.row}`}>
      <div className="p-field">
        <Button
          id={`stat-run-button-custom-question-${model.id}`}
          className={classNames(
            `stat-run-button-${TYPE_CLASS_MAP[model.type]}`,
            `-dtr-stat-run-button-${TYPE_CLASS_MAP[model.type]}`,
            'p-button-grey p-button-rounded'
          )}
          data-stat-run-button={model.id}
          label={updateText}
          loading={states.loading}
          disabled={updateDisabled}
          onClick={updateDisabled ? null : onUpdateData}
        />
      </div>
      {children ? <div className={`${style.group} ${style.children} -col`}>{children}</div> : null}
    </div>
  )
}

Footer.propTypes = {
  children: PropTypes.any,
  model: PropTypes.object,
  states: PropTypes.object,
  updateTextPrefix: PropTypes.string,
  onUpdateData: PropTypes.func
}

Footer.displayName = 'Footer'

export default Footer
